export default (theme) => ({
  root: {
    padding: '18px',
    marginRight:'40px',
    alignItems: 'baseline',
    gap: '10px',
    borderRadius: '18px',
    backgroundColor: '#F8F9FC',
  },
  gap: {
    gap: '24px',
  },
  link: {
    color: '#009DA9',
    cursor: 'pointer',
  },
  timeLimitRemaining: {
    color: '#009DA9',
    fontWeight: 'bold',
  },
  timeRemainingText: {
    textTransform: 'none !important',
  },
});
